import React from 'react';
import './Svg.scss';
type Props = {
    onClick?: React.MouseEventHandler<SVGSVGElement>;
    className?: string;
    onTouchStart?: (e: React.TouchEvent) => void;
    onTouchEnd?: (e: React.TouchEvent) => void;
}
const Svg: React.FC<Props> = ({ children, onClick, className, onTouchStart, onTouchEnd }) => {
    return (
        <svg
            className={`bv-svg ${(className && className) || ''}`}
            version="1.1"
            onClick={onClick}
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
            viewBox='0 0 100 100'
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg">
            {children}
        </svg>
    );
};

export default Svg;
